import { selector } from 'recoil';
import { OnlineSales } from 'gw-edge-client';
import { isLoggedOnSelector } from './isLoggedOnSelector';
import { jobInfoAtom } from '../atoms/jobInfoAtom';
import { type AccountHolderDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/account';

export const getAccountHolderDataSelector = selector<AccountHolderDTO>({
    key: 'getAccountHolderDataSelector',
    get: async ({ get }) => {
        const { jobNumber, sessionId } = get(jobInfoAtom);
        const isLoggedOn = get(isLoggedOnSelector);
        if (!isLoggedOn) return {};

        return await OnlineSales.getAccountHolderData(jobNumber, sessionId);
    }
});
